import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory, useParams } from 'react-router-dom';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import BackIcon from '@material-ui/icons/ArrowBackIos';
import { useAccount } from 'hooks/use-account';
import InputIcon from '@material-ui/icons/Input';
import { usePeer } from 'hooks/use-room-peer';

interface Props {
  className?: string;
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  toolbar: {
    justifyContent: 'space-between',
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    marginBlockEnd: '0',
    cursor: 'pointer',
    textAlign: 'center',
    color: '#388e3c',
    margin: '0 auto',
  },
  logoutButton: {
    marginLeft: theme.spacing(1),
  },
}));

export const Header: FC<Props> = ({ className = '' }) => {
  const classes = useStyles();
  const { setName } = useAccount();
  const history = useHistory();
  const { id } = useParams<{id: string}>();
  const { close } = usePeer(id);

  // onBack
  const onBack = () => {
    close();
    history.goBack();
  };

  return (
    <AppBar color="inherit" className={`classes.root ${className}`} position="static">
      <Toolbar>
        <IconButton
          onClick={onBack}
          edge="start"
          className={classes.menuButton}
          color="inherit"
        >
          <BackIcon />
        </IconButton>

        <Typography variant="h6" className={classes.title}>
          Meet mans 
        </Typography>


        <IconButton
            className={classes.logoutButton}
            color="inherit"
            onClick={()=> {
              close();
              setName('') ;
            }}>
            <InputIcon />
          </IconButton>
      </Toolbar>
    </AppBar>
  );
};
